import { FormContainer } from 'react-hook-form-mui';

import type { IChangePasswordRequest } from '@treneo/models';
import {
  ChangePasswordSchema,
  FormButtons,
  PasswordAndConfirmPasswordFields,
  PasswordField,
  useAppFormWithValidation
} from '@treneo/shared/forms';
import { useAppTranslations } from '@treneo/shared/i18n';
import { Spacing } from '@treneo/shared/themes';
import { AlertError, AlertSuccess, Box, styled } from '@treneo/shared/ui';

import { changePasswordFormFieldNames } from '../../data/auth-form-field-names';

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.medium};
`;

type Props = {
  onSubmit: (formData: IChangePasswordRequest) => void;
  onCancel: () => void;
  error?: string | null;
  isSubmitSuccess?: boolean;
  isLoading?: boolean;
};

export const ChangePasswordForm = ({
  onSubmit,
  onCancel,
  error,
  isSubmitSuccess,
  isLoading = false
}: Readonly<Props>) => {
  const { t } = useAppTranslations();
  const formContext = useAppFormWithValidation<IChangePasswordRequest>(ChangePasswordSchema());

  return (
    <FormContainer onSuccess={onSubmit} formContext={formContext}>
      <Container>
        {error && <AlertError text={t(error, { ns: 'errors' })} />}

        {isSubmitSuccess && <AlertSuccess text={t('auth.passwordHasBeenChanged')} />}

        <PasswordField
          name={changePasswordFormFieldNames.oldPassword}
          label={t('auth.oldPassword')}
        />

        <PasswordAndConfirmPasswordFields
          formContext={formContext}
          passwordLabel={t('auth.newPassword')}
        />

        <FormButtons
          onSubmit={() => {}}
          onCancel={onCancel}
          submitText={t('Save')}
          cancelText={t('Cancel')}
          isDisabled={!formContext.isValid || isLoading}
          isLoading={isLoading}
          loadingText={t('common.saving')}
        />
      </Container>
    </FormContainer>
  );
};
